import React, { memo } from 'react'

import style from './SimulatorHeader.module.css'
import { Timer } from './Timer/Timer'

import { useAppSelector, useDocumentTitle } from 'common/hooks'
import { selectCategoryByTaskId } from 'features/dashboard'

type PropsType = {
  id: string
}

export const SimulatorHeader = memo(({ id }: PropsType) => {
  const category = useAppSelector(state => selectCategoryByTaskId(state, id))

  useDocumentTitle(`Тренировка по ${category?.title}`)

  return (
    <div className={style.box}>
      <h2 className={`${style.title} section-title`}>Тренировка по {category?.title}</h2>
      <Timer />
    </div>
  )
})
